import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { routes } from '../../const';

const PrivateRoute = ({
  isAuthenticated,
  children,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: routes.LOGIN,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
